module.exports = __webpack_public_path__ + "static/media/plaza-tirana.adf4568f.png";